import { appConfig } from '../config/app-config';
import { client } from './client';

export function getClassifications() {
  return client(
    'classifications/processed',
    { method: 'GET' },
    appConfig.apiUrls.micro
  );
}

export function getPricingClassifications() {
  return client(
    `classification`,
    {
      method: 'POST',
      body: getPayload(),
    },
    appConfig.apiUrls.micro,
    true
  );
}

export function getPayload() {
  return { storeNumber: [window.sessionStorage.getItem('storeNumber')] };
}
